import { SvgIcon, SvgIconProps } from '@mui/material';

/** @deprecated Use theme-next icons or move into theme-next folder if it doesn't exists */
export const EmailIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 20 21" {...props}>
            <path
                d="M10 13.5035C11.841 13.5035 13.3334 12.0112 13.3334 10.1702C13.3334 8.32926 11.841 6.83688 10 6.83688C8.15907 6.83688 6.66669 8.32926 6.66669 10.1702C6.66669 12.0112 8.15907 13.5035 10 13.5035Z"
                fill="none"
                stroke={props.htmlColor ?? '#21272E'}
                strokeWidth="1.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.3334 6.83688V11.0035C13.3334 11.6666 13.5968 12.3025 14.0656 12.7713C14.5344 13.2402 15.1703 13.5035 15.8334 13.5035C16.4964 13.5035 17.1323 13.2402 17.6011 12.7713C18.07 12.3025 18.3334 11.6666 18.3334 11.0035V10.1702C18.3332 8.2894 17.6969 6.46394 16.5278 4.99065C15.3586 3.51737 13.7255 2.4829 11.8939 2.05546C10.0623 1.62802 8.13997 1.83275 6.43948 2.63635C4.739 3.43995 3.36036 4.79517 2.52774 6.48165C1.69513 8.16812 1.4575 10.0867 1.8535 11.9253C2.2495 13.764 3.25584 15.4146 4.70889 16.6088C6.16193 17.803 7.97622 18.4705 9.85675 18.5028C11.7373 18.5352 13.5735 17.9304 15.0667 16.7869"
                fill="none"
                stroke={props.htmlColor ?? '#21272E'}
                strokeWidth="1.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};
